import { useEffect, useState } from "react";

/**
 * 버퍼링 표시가 뜨기까지의 지연(ms). 빠른 망에서도 재생 시작·seek마다 수십~수백 ms 멈추는데,
 * 그때마다 Spinner가 깜빡이지 않게 이보다 오래 이어질 때만 보인다. 멈춤 자체와 status는 지연하지 않는다.
 */
export const BUFFERING_INDICATOR_DELAY_MS = 300;

/** `active`가 `delayMs` 넘게 이어졌을 때만 true다. false로 돌아오면 곧바로 false다. */
export function useDelayedFlag(active: boolean, delayMs: number): boolean {
  const [elapsed, setElapsed] = useState(false);

  useEffect(() => {
    setElapsed(false);
    if (!active) return undefined;
    const timer = setTimeout(() => setElapsed(true), delayMs);
    return () => clearTimeout(timer);
  }, [active, delayMs]);

  return active && elapsed;
}
